import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RoleGuard } from 'src/app/guards/role-guard';

// Components
import { FastfetchComponent } from './components/fastfetch/fastfetch.component';
import { LBADataswapComponent } from './components/lba-dataswap/lba-dataswap.component';

export const routes: Routes = [
  {
    path: 'dataswap',
    component: LBADataswapComponent,
    canActivate: [RoleGuard],
    data: {
      title: 'DataSwap',
      requiredRoles: ['LOSTalker.Integration.CompenSafe.DataSwap', 'LOSTalker.Integration.LimeGear.DataSwap'],
    },
  },
  {
    path: 'fastfetch',
    component: FastfetchComponent,
    canActivate: [RoleGuard],
    data: {
      title: 'Fast Fetch',
      requiredRoles: ['LOSTalker.Integration.CompenSafe.FastFetch', 'LOSTalker.Integration.LimeGear.FastFetch'],
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LTProcessDataRoutingModule { }
